"use client"

import { useTheme } from "next-themes"
import { Toaster as Sonner, type ToasterProps } from "sonner"
import {
  CircleCheckIcon,
  InfoIcon,
  TriangleAlertIcon,
  OctagonXIcon,
  Loader2Icon,
} from "lucide-react"

/**
 * Shadcn Sonner Toaster with Nova design tokens
 * Uses Nova color palette for consistent branding
 */
const Toaster = ({ ...props }: ToasterProps) => {
  const { theme = "system" } = useTheme()

  return (
    <Sonner
      theme={theme as ToasterProps["theme"]}
      className="toaster group !z-[9999]"
      icons={{
        success: <CircleCheckIcon className="size-4 text-[#166083]" />,
        info: <InfoIcon className="size-4 text-[#2d708f]" />,
        warning: <TriangleAlertIcon className="size-4 text-amber-500" />,
        error: <OctagonXIcon className="size-4 text-red-600" />,
        loading: <Loader2Icon className="size-4 animate-spin text-[#166083]" />,
      }}
      style={
        {
          "--normal-bg": "var(--card)",
          "--normal-text": "var(--card-foreground)",
          "--normal-border": "var(--border)",
          "--border-radius": "var(--radius-lg)",
          zIndex: 9999,
        } as React.CSSProperties
      }
      toastOptions={{
        classNames: {
          toast: "group toast !z-[9999]",
          title: "text-sm font-semibold",
          description: "text-sm opacity-90",
          actionButton: "bg-[#166083] text-white hover:bg-[#145676]",
          cancelButton: "bg-muted text-muted-foreground hover:bg-muted/80",
        },
      }}
      offset={24}
      {...props}
    />
  )
}

export { Toaster }
